const SERVICE_ACCOUNT_TYPE_RESOLVED = ['service_account', 'scanner', 'dormant'];
const ACCOUNT_TYPE = {
    MANAGED_SERVICE_ACCOUNT: 'Managed Service Account',
    SERVICE_ACCOUNT: 'Service Account',
    USER: 'User'
};

exports.getAccountType = (isGmsa, typeResolved, removed) => {
    if (isGmsa) {
        return ACCOUNT_TYPE.MANAGED_SERVICE_ACCOUNT;
    } else if (SERVICE_ACCOUNT_TYPE_RESOLVED.includes(typeResolved) && !removed) {
        return ACCOUNT_TYPE.SERVICE_ACCOUNT;
    }
    return ACCOUNT_TYPE.USER;
};
